import styled from 'styled-components';
import BgGradient from '../../../../assets/imgs/gradient.png';

const WelcomeBody = styled.div`
	display: flex;
	flex-direction: column;
	// position: absolute;
	// top: 0;
	// left: 0;
	// right: 0;
	// bottom: 0;
	// background-image:url(${BgGradient}) !important;
	// background-repeat:no-repeat !important;
	// background: radial-gradient(circle at 0% 0%, rgb(47, 177, 145), rgb(47, 177, 145) 25%, white 75%);
	// box-shadow: 0px 3px 46px #00000029;
	padding: 30px;
	max-height: 100%;
	// overflow: hidden !important;
	overflow-y: auto;
	// background-size: cover;
	z-index: 99999;
`;
export default WelcomeBody;
